import { useReducer } from 'react';
import { CreditUserReducer } from './CreditUserReducer';
import { CreditUserContext } from './CreditUserContext';
import { UPDATE_CREDIT_USER, UPDATE_DATOS_VARIOS, UPDATE_DEUDA_HOY_BACKEND } from './types';
import { calcularFechas } from '../../components/credits/calculoFechas';
import moment from 'moment';

export const CreditUserState = (props) => {

    const calcularTotalAPagar = (vence) => {
        //Calcular interes
        let Amount = parseInt("200000");
        const interest = Math.round(
            Amount * (0.0626666 / 100) * vence
        );
        const admon = 60000;
        //Calcular IVA
        const iva = Math.round(admon * (19 / 100));
        //Calcular Total
        const total = Math.round(Amount + interest + admon + iva);
        return total;
    }
    const fechasOptions = calcularFechas();
    const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
    const vence2 = fechasOptions.fecha2.diff(moment(), "days") + 1;

    const initialState = {
        creditUser: {
            credit_id: "",
            requestedAmount: "",
            approvedQuota: "200000",
            termInDays: vence2,
            totalToPay: calcularTotalAPagar(vence2),
            paydayLimit: dateLimit2,
            documento: "",
            acceptanceDate: "",
            approvedDate: "",
            signatureDate: "",
            status: ""
        },
        datosVarios: {
            deudaHoy: "",
            hasMora: false,
            diasMora: 0,
            statusCredit: "",
            cupoDisponible: ""
        },
        deudaHoyBackend: {}
    }

    const [state, dispatch] = useReducer(CreditUserReducer, initialState);

    const updateCreditUser = (data) => {

        dispatch({
            type: UPDATE_CREDIT_USER,
            payload: data
        })
    }

    const updateDatosVarios = (data) => {

        dispatch({
            type: UPDATE_DATOS_VARIOS,
            payload: data
        })
    }

    const updateDeudaHoyBackend = (data) => {

        dispatch({
            type: UPDATE_DEUDA_HOY_BACKEND,
            payload: data
        })
    }

    return (
        <CreditUserContext.Provider value={
            {
                creditUser: state.creditUser,
                updateCreditUser,
                updateDatosVarios,
                updateDeudaHoyBackend,
                datosVarios: state.datosVarios,
                deudahoyBackend: state.deudaHoyBackend
            }}>
            {props.children}
        </CreditUserContext.Provider>
    )

}


